'use client';

import { useParams } from 'next/navigation';

export default function useProductIdParam() {
  return useParams<{ productId: string }>().productId?.split('-').slice(-1)[0];
}
